<div class="history-item"
     [ngClass]="{'clickable-history-item': !someHistoryItemLoading}"
     [ngStyle]="{'padding': editingChatName ? '0 0.75rem' : '0.5rem 0 0.5rem 0.5rem'}"
     (mouseenter)="isHovered = true"
     (mouseleave)="onChatHistoryMenuMouseLeave()">
  <div *ngIf="!editingChatName"
       class="my-auto ms-2 text-truncate"
       [ngClass]="{'current-chat': isCurrentChat}"
       [pTooltip]="chat.name"
       (mousedown)="loadHistory()">
       {{chat.name}}
  </div>
  <div *ngIf="!editingChatName && isHovered" style="min-width: 115px;">
      <p-button icon="pi pi-pencil" [text]="true" severity="secondary" (onClick)="editChatName()"/>
      <p-button icon="pi pi-trash" [text]="true" severity="secondary" (onClick)="deleteChatHistory()"/>
      <p-button [icon]="isPinned() ? 'pi pi-bookmark-fill' : 'pi pi-bookmark'" [text]="true" severity="secondary" (onClick)="togglePin()"/>
  </div>
  <div *ngIf="editingChatName" class="my-auto ms-3 d-flex">
    <input id="edit-chat-name" type="text" pInputText [(ngModel)]="chatName"/>
  </div>
</div>
